import { EuiChipComponent } from '../../eui-chip/eui-chip.component';

export class EuiChipDragDrop {
    type: string;
    sourceName: string;
    chip: EuiChipComponent;
    chips: EuiChipComponent[];

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
